import { useQuery } from '@tanstack/react-query';
import {
  fetchPublicStatus,
  fetchPublicUptime,
  fetchPublicIncidents,
  fetchPublicMaintenances,
} from './api.ts';

export const publicKeys = {
  status: ['public', 'status'] as const,
  uptime: ['public', 'uptime'] as const,
  incidents: ['public', 'incidents'] as const,
  maintenances: ['public', 'maintenances'] as const,
};

/** Status atual — refetch a cada 60s */
export function usePublicStatus() {
  return useQuery({
    queryKey: publicKeys.status,
    queryFn: fetchPublicStatus,
    refetchInterval: 60_000,
  });
}

/** Uptime + histórico 90 dias — refetch a cada 5min */
export function usePublicUptime() {
  return useQuery({
    queryKey: publicKeys.uptime,
    queryFn: fetchPublicUptime,
    refetchInterval: 5 * 60_000,
  });
}

/** Incidentes abertos + histórico — refetch a cada 60s */
export function usePublicIncidents() {
  return useQuery({
    queryKey: publicKeys.incidents,
    queryFn: fetchPublicIncidents,
    refetchInterval: 60_000,
  });
}

/** Manutenções agendadas — refetch a cada 5min */
export function usePublicMaintenances() {
  return useQuery({
    queryKey: publicKeys.maintenances,
    queryFn: fetchPublicMaintenances,
    refetchInterval: 5 * 60_000,
  });
}
